import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, BookOpen, Settings, BadgeCheck, User, ShoppingBag, PhoneCall } from "lucide-react";

const navItems = [
    { path: "/home", icon: <Home size={22} />, label: "Home" },
    { path: "/products", icon: <ShoppingBag size={22} />, label: "Products" },
    { path: "/contact", icon: <PhoneCall size={22} />, label: "Contact" },
    { path: "/my-account", icon: <User size={22} />, label: "Account" },
];


const MobileBottomNav = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <div className="ecommerce-theme2-mobile-bottom-nav">
            {navItems.map(({ path, icon, label }) => {
                const isActive = location.pathname === path;
                return (
                    <div
                        key={path}
                        className={`ecommerce-theme2-mobile-nav-item ${isActive ? "active" : ""
                            }`}
                        onClick={() => navigate(path)}
                    >
                        {icon}
                        {isActive && <span>{label}</span>}
                    </div>
                );
            })}
        </div>
    );
};

export default MobileBottomNav;
